import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { TermsAndConditionsStore, TermsAndConditionsState } from './terms-and-conditions.store';
import { TermsAndConditionsModel } from './models/terms-and-conditions.model';
import { TermsAndConditionsType } from './models/terms-and-conditions-type.model';

@Injectable({ providedIn: 'root' })
export class TermsAndConditionQuery extends QueryEntity<TermsAndConditionsState> {
  constructor(protected store: TermsAndConditionsStore) {
    super(store);
  }

  /** Select terms and conditions by type and lcid.
   * @param selectedType terms and condition type
   * @param lcid language variant to be displayed
   */
  selectTermsAndConditions(selectedType: TermsAndConditionsType, lcid: number): Observable<TermsAndConditionsModel[]> {
    return this.selectAll({
      filterBy: (entity) => entity.Type === selectedType && entity.LCID === lcid,
    });
  }

  /** Checks if there are terms of specific type in store.
   * @param termsType terms and condition type
   */
  hasTerms(termsType: TermsAndConditionsType): boolean {
    return Boolean(this.getAll({ filterBy: [(entity) => entity.Type == termsType] }).length);
  }
}
